import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
// Set your offer expiration time here (e.g., 24 hours from now)
const OFFER_DURATION_SECONDS = 24 * 60 * 60;
// Set your expiry timestamp (24 hours from now)
const EXPIRY_TIMESTAMP = Math.floor(Date.now() / 1000) + 24 * 60 * 60;

function getRemainingTime(expiryTimestamp) {
  const now = Math.floor(Date.now() / 1000);
  const diff = expiryTimestamp - now;
  if (diff <= 0) return { hours: '00', minutes: '00', seconds: '00', expired: true };
  const hours = String(Math.floor(diff / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
  const seconds = String(diff % 60).padStart(2, '0');
  return { hours, minutes, seconds, expired: false };
}

export default function OfferTimer({ expiryTimestamp }) {
  const [timeLeft, setTimeLeft] = useState(getRemainingTime(expiryTimestamp));

  useEffect(() => {
    if (timeLeft.expired) return;
    const timer = setInterval(() => {
      setTimeLeft(getRemainingTime(expiryTimestamp));
    }, 1000);
    return () => clearInterval(timer);
  }, [expiryTimestamp, timeLeft.expired]);

  if (timeLeft.expired) {
    return <div className="text-warning-500 text-sm font-medium">⚡ Offer expired!</div>;
  }

  return (
    <div className="text-warning-500 text-sm font-medium">
      ⚡ Offer expires in {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}
    </div>
  );
}

export const mountTimer = () => {
  const rootEl = document.getElementById('offer-timer');
  if (rootEl) {
    const expiryTimestamp = EXPIRY_TIMESTAMP;
    const root = createRoot(rootEl);
    root.render(<OfferTimer expiryTimestamp={expiryTimestamp} />);
  }
};
